import { fork } from 'redux-saga/effects';

import AdminGateway from '~apis/admin';
import { RootSagaReturnType } from '~types/saga';

import watchGetAdminListing from './getAdminListing';
import watchGetRoleListing from './getRoleListing';
import watchCreateNewRole from './createNewRole';
import watchEditRoleDetails from './editRoleDetails';
import watchDeleteRole from './deleteRole';
import watchGetAllRoles from './getAllRoles';
import watchCreateNewAdmin from './createNewAdmin';
import watchEditAdminDetails from './editAdminDetails';
import watchDeleteAdmin from './deleteAdmin';
import watchExportAdminUserListing from './exportAdminUserListing';
import watchExportAdminRoleListing from './exportAdminRoleListing';

export default (api: AdminGateway): RootSagaReturnType => {
    function* rootSaga() {
        yield fork(watchGetAdminListing, api);
        yield fork(watchGetRoleListing, api);
        yield fork(watchCreateNewRole, api);
        yield fork(watchEditRoleDetails, api);
        yield fork(watchDeleteRole, api);
        yield fork(watchGetAllRoles, api);
        yield fork(watchCreateNewAdmin, api);
        yield fork(watchEditAdminDetails, api);
        yield fork(watchDeleteAdmin, api);
        yield fork(watchExportAdminUserListing, api);
        yield fork(watchExportAdminRoleListing, api);
    }

    return {
        rootSaga,
    };
};
